import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ProductType} from "../models/product";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-product-type-selection',
  template: `
    <div class="products-container">
      <ul class="nav nav-tabs nav-fill  product-list">
        <li class="nav-item pointer-style" *ngFor="let productType of productTypes" (click)="onClick(productType)">
          <a class="nav-link" [class.active]="productType === selected">{{ label(productType) }}</a>
        </li>
      </ul>
    </div>
  `,
  styles: [`
    .pointer-style {
      cursor: pointer;
    }

    .product-list {

      border-bottom: 2px solid  var(--customer-primary-color);

      .nav-item {
        .nav-link {
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;

          &.active {
            background-color: var(--customer-primary-color) !important;
            border-color: var(--customer-primary-color) !important;
            color: var(--customer-primary-text-color) !important;
          }
        }
      }
    }
  `]
})
export class ProductTypeSelection {
  private _defaultProductType: ProductType = 'door'
  private _productTypes: Array<ProductType> = ['door', 'handle']

  constructor(protected translationService: TranslateService) {
  }

  @Output() selectedChange = new EventEmitter<ProductType>();

  @Input() selected: ProductType = 'door'

  public onChanged(productType: ProductType) {
    this.selectedChange.emit(productType)
  }

  public label(productType: ProductType): string {
    return this.translationService.instant(`productType.${productType}`)
  }

  public onClick(productType: ProductType) {
    this.selected = productType
    this.onChanged(productType)
  }

  @Input() set defaultProductType(defaultProductType: ProductType) {
    this._defaultProductType = defaultProductType
  }


  get defaultProductType() {
    return this._defaultProductType
  }

  @Input() set productTypes(ProductTypes: Array<ProductType>) {
    this._productTypes = ProductTypes
  }

  get productTypes() {
    return this._productTypes
  }

  public getProductTypeIcon(productType: ProductType): string | undefined {
    return undefined
  }

  public getProductTypeLabel(productType: ProductType) {
   return productType
  }
}

